import { ArrowUpRight, Mail, MapPin, Phone } from "lucide-react";
import Reveal from "./Reveal";
import { ArrowRosette } from "./Logo";

const Contact = () => (
  <section id="contato" className="border-t border-navy bg-navy text-white" data-testid="contact-section">
    <div className="px-6 pt-24 lg:px-12 lg:pt-36">
      <Reveal>
        <span className="font-mono text-xs uppercase tracking-[0.35em] text-white/50">
          04 / Contato
        </span>
      </Reveal>
      <Reveal delay={0.08}>
        <h2
          className="mt-6 font-oswald font-bold uppercase leading-[0.9] tracking-tight text-[clamp(3.5rem,13vw,12rem)]"
          data-testid="contact-heading"
        >
          Fale com a JVF
        </h2>
      </Reveal>
      <Reveal delay={0.14}>
        <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-white/60 lg:text-lg">
          Fale diretamente com quem executa o seu despacho. Sem call center,
          sem intermediários.
        </p>
      </Reveal>
    </div>

    <div className="mt-16 lg:mt-24">
      <Reveal>
        <a
          href="tel:+555332018201"
          data-testid="contact-phone-link"
          className="group flex items-center justify-between gap-6 border-t border-white/15 px-6 py-10 transition-colors duration-300 hover:bg-white lg:px-12 lg:py-14"
        >
          <div className="flex items-center gap-6">
            <Phone size={22} className="text-white/50 transition-colors duration-300 group-hover:text-navy" />
            <div>
              <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 transition-colors duration-300 group-hover:text-navy/50">
                Telefone
              </span>
              <span className="font-oswald text-2xl font-semibold tracking-tight transition-colors duration-300 group-hover:text-navy sm:text-4xl lg:text-5xl">
                (53) 3201-8201
              </span>
            </div>
          </div>
          <ArrowUpRight
            size={32}
            className="shrink-0 text-white/50 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-navy"
          />
        </a>
      </Reveal>

      <Reveal>
        <a
          href="/contato"
          data-testid="contact-email-link"
          className="group flex items-center justify-between gap-6 border-t border-white/15 px-6 py-10 transition-colors duration-300 hover:bg-white lg:px-12 lg:py-14"
        >
          <div className="flex items-center gap-6">
            <Mail size={22} className="text-white/50 transition-colors duration-300 group-hover:text-navy" />
            <div>
              <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 transition-colors duration-300 group-hover:text-navy/50">
                E-mail
              </span>
              <span className="break-all font-oswald text-xl font-semibold tracking-tight transition-colors duration-300 group-hover:text-navy sm:text-3xl lg:text-4xl">
                contato@jvfdespachos.com.br
              </span>
            </div>
          </div>
          <ArrowUpRight
            size={32}
            className="shrink-0 text-white/50 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-navy"
          />
        </a>
      </Reveal>

      <Reveal>
        <div
          className="flex items-center gap-6 border-y border-white/15 px-6 py-10 lg:px-12 lg:py-14"
          data-testid="contact-location"
        >
          <MapPin size={22} className="text-white/50" />
          <div>
            <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
              Base
            </span>
            <span className="font-oswald text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl">
              Rio Grande do Sul — Brasil
            </span>
          </div>
        </div>
      </Reveal>

      <Reveal>
        <a
          href="/contato"
          data-testid="contact-quote-cta"
          className="group flex items-center justify-between gap-6 border-b border-white/15 bg-white px-6 py-8 text-navy transition-colors duration-300 hover:bg-white/85 lg:px-12 lg:py-10"
        >
          <div>
            <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-navy/50">
              Formulário
            </span>
            <span className="font-oswald text-2xl font-semibold tracking-tight sm:text-3xl lg:text-4xl">
              Solicite uma cotação pelo site
            </span>
          </div>
          <ArrowUpRight
            size={32}
            className="shrink-0 text-navy/60 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1"
          />
        </a>
      </Reveal>
    </div>

    <footer
      className="flex flex-col items-start justify-between gap-8 px-6 py-12 lg:flex-row lg:items-center lg:px-12"
      data-testid="site-footer"
    >
      <div className="flex items-center gap-4">
        <ArrowRosette className="h-10 w-10 text-white/60" />
        <div>
          <p className="font-oswald text-sm font-semibold uppercase tracking-wide">
            JVF Assessoria e Despachos Aduaneiros LTDA
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
            Cotações: Banco Central do Brasil — PTAX
          </p>
        </div>
      </div>
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
        © {new Date().getFullYear()} — Todos os direitos reservados
      </p>
    </footer>
  </section>
);

export default Contact;
